import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faBars, faTimes, faMapMarkerAlt, faSearch } from '@fortawesome/free-solid-svg-icons';
import './Navbar.css';

const translations = {
  en: {
    slogan: "Original Makers. OEM Partners.",
    home: "Home",
    products: "Our Products",
    about: "About Us",
    contact: "Contact Us",
    career: "Karir",
    searchPlaceholder: "Search...",
    searchButton: "Go"
  },
  id: {
    slogan: "Produsen Asli. Mitra OEM Terpercaya.",
    home: "Beranda",
    products: "Produk Kami",
    about: "Tentang Kami",
    contact: "Hubungi Kami",
    career: "Karir",
    searchPlaceholder: "Cari...",
    searchButton: "Cari"
  },
  cn: {
    slogan: "原始制造者，OEM合作伙伴。",
    home: "首页",
    products: "我们的产品",
    about: "关于我们",
    contact: "联系我们",
    career: "Karir",
    searchPlaceholder: "搜索...",
    searchButton: "搜索"
  }
};

function MyNavbar() {
  const [showSearch, setShowSearch] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showLanguageMenu, setShowLanguageMenu] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [lang, setLang] = useState('en');

  const t = translations[lang];
  const navigate = useNavigate();

  const handleSearchToggle = () => {
    setShowSearch(!showSearch);
  };

  const handleLanguageChange = (selectedLang) => {
    setLang(selectedLang);
    setShowLanguageMenu(false);

    if (selectedLang === 'id') navigate('/home-id');
    else if (selectedLang === 'cn') navigate('/home-cn');
    else navigate('/');
  };

  const handleGlobeClick = () => {
    if (window.innerWidth <= 768) {
      setShowLanguageMenu(!showLanguageMenu);
    }
  };

  return (
    <div className="custom-navbar border-bottom">
      {/* Top Bar */}
      <div className="navbar-top">
        <div className="navbar-top-inner">
          <div className="brand-logo">
            <img src="images/LOGO - WHITE GOLD.png" alt="FORMEB Logo" className="company-logo" />
          </div>

          <div className="navbar-slogan">{t.slogan}</div>

          <div className="navbar-icons">
            {/* Desktop: Language buttons */}
            <div className="navbar-lang desktop-only">
              <button onClick={() => handleLanguageChange('id')} className="language-btn">IDN</button>
              <span>/</span>
              <button onClick={() => handleLanguageChange('en')} className="language-btn">EN</button>
              <span>/</span>
              <button onClick={() => handleLanguageChange('cn')} className="language-btn">CN</button>
            </div>

            {/* Always show globe, only clickable on mobile */}
            <button className="icon-button globe-icon" onClick={handleGlobeClick}>
              <FontAwesomeIcon icon={faGlobe} />
            </button>

            {/* Hamburger icon: only mobile */}
            <button className="icon-button hamburger-toggle mobile-only" onClick={() => setShowMobileMenu(!showMobileMenu)}>
              <FontAwesomeIcon icon={showMobileMenu ? faTimes : faBars} />
            </button>
          </div>

          {/* Mobile language dropdown */}
          {showLanguageMenu && (
            <div className="language-dropdown mobile-only">
              <button onClick={() => handleLanguageChange('id')} className="language-option">IDN</button>
              <button onClick={() => handleLanguageChange('en')} className="language-option">EN</button>
              <button onClick={() => handleLanguageChange('cn')} className="language-option">CN</button>
            </div>
          )}
        </div>
      </div>

      {/* Bottom Bar */}
      <div className={`navbar-bottom ${showMobileMenu ? 'show' : ''}`}>
        <div className="nav-links">
          <Link to={lang === 'en' ? '/' : `/home-${lang}`} className="nav-item">{t.home}</Link>
          <Link to={`/products${lang === 'en' ? '' : `-${lang}`}`} className="nav-item">{t.products}</Link>
          <Link to={`/about${lang === 'en' ? '' : `-${lang}`}`} className="nav-item">{t.about}</Link>
          <Link to={`/contact${lang === 'en' ? '' : `-${lang}`}`} className="nav-item">{t.contact}</Link>
          <Link to={`/career${lang === 'en' ? '' : `-${lang}`}`} className="nav-item">{t.career}</Link>

          <a
            href="https://maps.app.goo.gl/rB3QaeGoud3LiXzy6"
            target="_blank"
            rel="noopener noreferrer"
            className="icon-button"
            title="View Location"
          >
            <FontAwesomeIcon icon={faMapMarkerAlt} />
          </a>

          <button className="icon-button" title="Search" onClick={handleSearchToggle}>
            <FontAwesomeIcon icon={faSearch} />
          </button>
        </div>
      </div>

      {/* Search Bar */}
      {showSearch && (
        <div className="search-bar text-end px-3 py-2 bg-light border-top">
          <form onSubmit={(e) => {
            e.preventDefault();
            if (searchText.trim()) {
              alert(`${t.searchButton}: ${searchText}`);
            }
          }} className="d-inline-flex align-items-center gap-2">
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder={t.searchPlaceholder}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: '200px' }}
            />
            <button type="submit" className="btn btn-dark btn-sm">{t.searchButton}</button>
          </form>
        </div>
      )}
    </div>
  );
}

export default MyNavbar;
